
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function getButtonList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu/btn',
    method: 'GET',
    params: parameter
  })
}

export function updateButton (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu/btn',
    method: 'PUT',
    data: parameter
  })
}

export function addButton (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu/btn',
    method: 'POST',
    data: parameter
  })
}

export function deleteButton (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/menu/btn/${parameter}`,
    method: 'DELETE'
  })
}
// 获取select数据
export function getQuery (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
